export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Message, TreeDataItem, TreeNode, TreeDragEndData} from 'kpc';

interface Props {
    data?: TreeDataItem<string>[]
    expandedKeys?: string[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            data: [
                {
                    label: 'First floor-1',
                    key: '1',
                    children: [
                        {
                            label: 'Second floor-1.1',
                            key: '1-1',
                            children: [
                                {
                                    label: 'This node can not be dragged and dropped.',
                                    key: '1-1-1'
                                }
                            ]
                        }
                    ]
                },
                {
                    label: 'First floor-2',
                    key: '2',
                    children: [
                        {
                            label: 'Second floor-2.1',
                            key: '2-1',
                            children: [
                                {
                                    label: 'Third floor-2.1.1',
                                    key: '2-1-1' 
                                },
                                {
                                    label: 'Third floor-2.1.2',
                                    key: '2-1-2'
                                }
                            ]
                        },
                        {
                            label: 'Second floor-2.2',
                            key: '2-2',
                            children: [
                                {
                                    label: 'Third floor-2.2.1',
                                    key: '2-2-1'
                                }
                            ]
                        },
                        {
                            label: 'Second floor-2.3',
                            key: '2-3',
                            disabled: true
                        }
                    ]
                }
            ],
            expandedKeys: ['2', '2-1'],
        };
    }

    onDragEnd(data: TreeDragEndData<string>) {
        console.log(data);
    }

    allowDrag(node: TreeNode<string>) {
        return node.key !== '1-1-1';
    }

    allowDrop(node: TreeNode<string>) {
        return node.key !== '1-1-1';
    }

    onDenyDrag(node: TreeNode<string>) {
        Message.error(`Cannot drag node: ${node.data.label}.`);
    }

    onDenyDrop(node: TreeNode<string>) {
        Message.error(`Cannot drop to node: ${node.data.label}.`);
    }
}